import {store} from "./redux/store";
import * as process from "process";

export const DATE_FORMAT = "dd/MM/yyyy";
export const DATE_FORMAT_SLASH = "yyyy / MM / dd";
export const DATE_FORMAT_DASH = "yyyy-MM-dd";

export const DEV_ONLY =
  process.env.NODE_ENV === "development" || (typeof window !== "undefined" && (window?.origin === "https://oct-dev.web3m.io" || window?.origin === "https://oct-develop-dot-winky-products.uc.r.appspot.com"));
export const STAGING = (typeof window !== "undefined" && (window?.origin === "https://oct-staging.web3m.io" || window?.origin === "https://oct-staging-dot-winky-products.uc.r.appspot.com"));
export const PROD_ONLY = process.env.NODE_ENV === "production";

export const storageToken =
  "@@auth0spajs@@::qf5Jo1duOIMoqzem70sDy74oW7dhs6Hp::https://dev-s5y764on.us.auth0.com/api/v2/::openid profile email read:current_user update:current_user_metadata offline_access";

export const appLink = `https://${DEV_ONLY ? "dev" : STAGING ? "stag" : "app"}.web3m.io`;
export const websiteLink = `https://${DEV_ONLY ? "advertisers." : ""}web3m.io`;
export const LinkSignUp = `https://${DEV_ONLY ? "advertisers." : ""}web3m.io/signup`;

export const userId = () => typeof window !== "undefined" && store.getState().user.userId;